import { render, staticRenderFns } from "./OBottomButtons.vue?vue&type=template&id=33422d03&"
import script from "./OBottomButtons.vue?vue&type=script&lang=js&"
export * from "./OBottomButtons.vue?vue&type=script&lang=js&"
import style0 from "./OBottomButtons.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports